const HERO_STATS = [
  { value: '126', label: '今日更新爆料' },
  { value: '12', label: '覆盖热门话题' },
  { value: '6', label: '常驻爆料频道' },
  { value: '5min', label: '快速看懂今天' },
];

const TICKER = [
  '顶流男星深夜密会传闻',
  '带货主播售后争议',
  '综艺同框被反复解读',
  '女团见面会临时改期',
  '短视频搬运争议升级',
  '巡演预热页面流出',
  '片场路透造型解读',
  '情侣艺人同框被拍',
];

export default function Hero() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="relative w-full">
      <div className="relative w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20moody%20nighttime%20cityscape%20with%20deep%20crimson%20and%20amber%20light%20haze%2C%20abstract%20blurred%20neon%20reflections%20and%20dramatic%20dark%20atmosphere%20with%20strong%20contrast%20suitable%20for%20white%20text%20overlay%2C%20stylized%20artistic%20editorial%20background%20with%20subtle%20film%20grain&width=1920&height=1080&seq=baoliao-hero-bg-01&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/60"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/60 via-transparent to-secondary-950/40"></div>

        <div className="relative z-10 w-full flex items-center min-h-[520px] md:min-h-[640px] pt-24 pb-20 md:pt-28 md:pb-24">
          <div className="w-full px-4 md:px-8">
            <div className="max-w-3xl fade-up">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-bold mb-5">
                <span className="w-2 h-2 rounded-full bg-background-50 dark:bg-foreground-950 animate-pulse"></span>
                今日爆料 · 实时更新中
              </span>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight mb-5">
                爆料网今日爆料
                <br />
                <span className="text-accent-300">一次看个够</span>
              </h1>
              <p className="text-base md:text-lg text-background-100 leading-relaxed max-w-2xl mb-8">
                网红黑料、明星绯闻与热门吃瓜事件，编辑部每天集中整理。每条内容都标注已知信息与待核实部分，让你吃瓜看得快，也看得清楚。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  type="button"
                  onClick={() => goTo('today')}
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
                >
                  <i className="ri-fire-line"></i>
                  查看今日爆料榜
                </button>
                <button
                  type="button"
                  onClick={() => goTo('featured')}
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors"
                >
                  <i className="ri-search-line"></i>
                  浏览吃瓜精选
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="relative z-20 bg-black/45 backdrop-blur-sm border-t border-white/10">
          <div className="w-full px-4 md:px-8 py-3 flex items-center gap-3 overflow-hidden">
            <span className="flex-shrink-0 inline-flex items-center gap-1 text-accent-300 text-xs font-bold whitespace-nowrap">
              <i className="ri-flashlight-fill"></i> 滚烫话题
            </span>
            <div className="relative flex-1 overflow-hidden">
              <div className="marquee-track text-sm text-background-100">
                {TICKER.map((t) => (
                  <span key={t} className="mr-8 whitespace-nowrap">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] align-middle mr-2 text-primary-400"></i>
                    {t}
                  </span>
                ))}
                {TICKER.map((t) => (
                  <span key={`dup-${t}`} className="mr-8 whitespace-nowrap">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] align-middle mr-2 text-primary-400"></i>
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8">
        <div className="pt-8 md:pt-10 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {HERO_STATS.map((stat, i) => (
            <div
              key={stat.label}
              className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5"
            >
              <div className="flex items-center justify-between">
                <div className="font-heading text-2xl md:text-3xl font-black text-primary-600">{stat.value}</div>
                <span
                  className={`w-8 h-8 flex items-center justify-center rounded-md text-sm ${
                    i % 3 === 0
                      ? 'bg-primary-100 text-primary-700'
                      : i % 3 === 1
                        ? 'bg-accent-100 text-accent-800'
                        : 'bg-secondary-100 text-secondary-800'
                  }`}
                >
                  <i
                    className={`${
                      i % 3 === 0 ? 'ri-fire-line' : i % 3 === 1 ? 'ri-radar-line' : 'ri-bookmark-line'
                    }`}
                  ></i>
                </span>
              </div>
              <div className="mt-2 text-xs md:text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}